import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../components/Login.vue";
import Home from "../components/Home.vue";
// 添加UIC_AUTH_KEYS导入
import { UIC_AUTH_KEYS } from "@/utils/auth";
// 导入动态路由工具
import { addDynamicRoutes } from "@/utils/dynamicRoutes";
// 添加扫码查询组件导入 👇
import ScanStockQuery from "@/view/stockQuery/ScanStockQuery.vue";
// 导入新页面组件
import Dashboard from "../view/Dashboard.vue";
import Profile from "../view/Profile.vue";
import UpdateLog from "../view/UpdateLog.vue";
import AboutUs from "../view/AboutUs.vue";
import ChangePassword from "../view/ChangePassword.vue";
import SystemSettings from "../view/SystemSettings.vue";

// 懒加载组件
// 1. 添加组件导入
const StockIn = () => import("../view/wareIn/StockIn.vue");
// 添加以下代码
const ScanStockIn = () => import("../view/wareIn/ScanStockIn.vue"); // 扫码入库(新)组件
const ScanStockInNew = () => import("../view/wareIn/ScanStockInNew.vue"); // 扫码入库(新)组件
const PLSScanStockIn = () => import("../view/wareIn/PLSScanStockIn.vue"); // PLS扫码入库组件
const PLSReceive = () => import("../view/wareIn/PLSReceive.vue");
const TclScanReceive = () => import("../view/wareIn/TclScanReceive.vue"); // TCL扫码收货
const TclScanOut = () => import("../view/wareOut/TclScanOut.vue"); // TCL扫码出库
// 添加扫码出库组件导入
const ScanStockOut = () => import("../view/wareOut/ScanStockOut.vue"); // 扫码出库组件
const ScanWareOut = () => import("../view/wareOut/ScanWareOut.vue"); // PDA扫码出库（按送货单号）
// 出库列表
const WareOutList = () => import("../view/wareOut/WareOutList.vue");
// 出库单列表
const WareOutOrderList = () => import("../view/wareOut/WareOutOrderList.vue");
// 导入扫码盘点组件
// 添加组件懒加载定义
const ScanStockCheck = () => import("../view/stockCheck/ScanStockCheck.vue");
const ScanCheckDetail = () => import("../view/stockCheck/ScanCheckDetail.vue");
// 导入手动盘点组件
const ManualStockCheckDetail = () =>
  import("../view/stockCheck/ManualStockCheckDetail.vue");
// 添加StockInOrder组件导入
const StockInOrder = () => import("../view/wareIn/StockInOrder.vue");
// 在文件顶部的懒加载组件部分添加
const ProjectTeamStockCheck = () =>
  import("../view/stockCheck/ProjectTeamStockCheck.vue");
const LocationStockCheck = () =>
  import("../view/stockCheck/LocationStockCheck.vue");
const WarehouseStockCheck = () =>
  import("../view/stockCheck/WarehouseStockCheck.vue");
const LocationStockCheckDetail = () =>
  import("../view/stockCheck/LocationStockCheckDetail.vue");
const StockTransfer = () => import("../view/stockTransfer/StockTransfer.vue");
const StockTransferDetail = () =>
  import("../view/stockTransfer/StockTransferDetail.vue");
const QualityTransfer = () =>
  import("../view/stockTransfer/QualityTransfer.vue");
const MaterialStockQuery = () =>
  import("../view/stockQuery/MaterialStockQuery.vue");
const StockWareQuery = () => import("../view/stockQuery/StockWareQuery.vue");

// 调拨管理
const MaterialSecondmentList = () =>
  import("../view/materialSecondment/MaterialSecondmentList.vue");

// 出库单打印
const WareOutPrintList = () => import("../view/wareOut/WareOutPrintList.vue");
const WareOutPrintPreview = () =>
  import("../view/wareOut/WareOutPrintPreview.vue");

// 入库收货/上架
const WareInReceive = () => import("../view/wareIn/WareInReceive.vue");
const WareInReceiveSingle = () =>
  import("../view/wareIn/WareInReceiveSingle.vue");
const WareInReceiveMultiPallet = () =>
  import("../view/wareIn/WareInReceiveMultiPallet.vue");
const WareInReceiveRedash = () =>
  import("../view/wareIn/WareInReceiveRedash.vue");
const WareInPutaway = () => import("../view/wareIn/WareInPutaway.vue");
const WareInPutawayDetail = () =>
  import("../view/wareIn/WareInPutawayDetail.vue");
const WareInPutawayScan = () => import("../view/wareIn/WareInPutawayScan.vue");
const WareInReceiveCreate = () =>
  import("../view/wareIn/WareInReceiveCreate.vue");
const WareInBatchReceive = () =>
  import("../view/wareIn/WareInBatchReceive.vue");

const LoadingOrderList = () =>
  import("../view/loadingOrder/LoadingOrderList.vue");
const LoadingOrderDetail = () =>
  import("../view/loadingOrder/LoadingOrderDetail.vue");

// 基础数据搜索
const BasicMaterialSearch = () =>
  import("../view/BasicMaterialSearch.vue");

// 导入备料相关组件
const MaterialPreparation = () =>
  import("../view/materialPreparation/materialPreparation.vue");
const PlsMaterialPreparation = () =>
  import("../view/materialPreparation/PlsMaterialPreparation.vue");
const PrepareList = () => import("../view/materialPreparation/PrepareList.vue");
const PrepareDetail = () =>
  import("../view/materialPreparation/PrepareDetail.vue");
const WareLocationCheck = () =>
  import("../view/materialPreparation/WareLocationCheck.vue");
const PlsResourceNoScan = () =>
  import("../view/materialPreparation/PlsResourceNoScan.vue");

const routes = [
  {
    path: "/",
    redirect: "/login",
    meta: { title: "重定向到登录页" },
  },
  // 登录页面路由
  {
    path: "/login",
    name: "LoginPage", // 修改为唯一名称
    component: Login,
    meta: { title: "登录" },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: { title: "首页", requiresAuth: true },
  },
  {
    path: "/stock-in",
    name: "StockIn",
    component: StockIn,
    meta: { title: "物料入库", requiresAuth: true },
  },
  // 添加以下代码
  {
    path: "/scan-stock-in",
    name: "ScanStockIn",
    component: ScanStockIn,
    meta: { title: "扫码入库", requiresAuth: true },
  },
  // 扫码入库(新)路由
  {
    path: "/scan-stock-in-new",
    name: "ScanStockInNew",
    component: ScanStockInNew,
    meta: { title: "扫码入库", requiresAuth: true },
  },
  // 添加PLS扫码入库路由
  {
    path: "/pls-scan-stock-in",
    name: "PLSScanStockIn",
    component: PLSScanStockIn,
    meta: { title: "PLS扫码入库", requiresAuth: true },
  },
  // 添加PLS扫码收货路由
  {
    path: "/pls-receive",
    name: "PLSReceive",
    component: PLSReceive,
    meta: { title: "PLS扫码收货", requiresAuth: true },
  },
  // 添加移动端PLS扫码收货路由
  {
    path: "/mobile/pls-receive",
    name: "MobilePLSReceive",
    component: PLSReceive,
    meta: { title: "PLS扫码收货", requiresAuth: true },
  },
  // TCL扫码收货
  {
    path: "/tcl-scan-receive",
    name: "TclScanReceive",
    component: TclScanReceive,
    meta: { title: "TCL扫码收货", requiresAuth: true },
  },
  {
    path: "/mobile/tcl-scan-receive",
    name: "MobileTclScanReceive",
    component: TclScanReceive,
    meta: { title: "TCL扫码收货", requiresAuth: true },
  },
  // TCL扫码出库
  {
    path: "/tcl-scan-out",
    name: "TclScanOut",
    component: TclScanOut,
    meta: { title: "TCL扫码出库", requiresAuth: true },
  },
  {
    path: "/mobile/tcl-scan-out",
    name: "MobileTclScanOut",
    component: TclScanOut,
    meta: { title: "TCL扫码出库", requiresAuth: true },
  },
  // 添加扫码出库路由
  {
    path: "/scan-stock-out",
    name: "ScanStockOut",
    component: ScanStockOut,
    meta: { title: "扫码出库", requiresAuth: true },
  },
  {
    path: "/mobile/scan-wareout",
    name: "MobileScanWareOut",
    component: ScanWareOut,
    meta: { title: "扫码出库", requiresAuth: true },
  },
  {
    path: "/wareout-list",
    name: "WareOutList",
    component: WareOutList,
    meta: { title: "出库列表", requiresAuth: true },
  },
  {
    path: "/mobile/wareout-list",
    name: "MobileWareOutList",
    component: WareOutList,
    meta: { title: "出库列表", requiresAuth: true },
  },
  {
    path: "/mobile/wareout-order",
    name: "MobileWareOutOrder",
    component: WareOutOrderList,
    meta: { title: "出库单", requiresAuth: true },
  },
  {
    path: "/wareout-print-list",
    name: "WareOutPrintList",
    component: WareOutPrintList,
    meta: { title: "出库单打印", requiresAuth: true },
  },
  {
    path: "/wareout-print-preview",
    name: "WareOutPrintPreview",
    component: WareOutPrintPreview,
    meta: { title: "打印预览", requiresAuth: true },
  },
  // 添加扫码盘点路由
  {
    path: "/scan-stock-check",
    name: "ScanStockCheck",
    component: ScanStockCheck,
    meta: { title: "扫码盘点", requiresAuth: true },
  },
  {
    path: "/scan-stock-check/detail/:id",
    name: "ScanCheckDetail",
    component: ScanCheckDetail,
    meta: { title: "扫码盘点详情", requiresAuth: true },
  },
  // 手动盘点详情页路由
  {
    path: "/manual-stock-check/detail/:id",
    name: "ManualStockCheckDetail",
    component: ManualStockCheckDetail,
    meta: { title: "手动盘点详情", requiresAuth: true },
  },
  {
    path: "/mobile/project-team-stock-check",
    name: "ProjectTeamStockCheck",
    component: ProjectTeamStockCheck,
    meta: { title: "项目组盘点", requiresAuth: true },
  },
  {
    path: "/mobile/location-stock-check",
    name: "LocationStockCheck",
    component: LocationStockCheck,
    meta: { title: "库位盘点", requiresAuth: true },
  },
  {
    path: "/mobile/warehouse-stock-check",
    name: "WarehouseStockCheck",
    component: WarehouseStockCheck,
    meta: { title: "库位盘点", requiresAuth: true },
  },
  {
    path: "/mobile/location-stock-check/detail/:id",
    name: "LocationStockCheckDetail",
    component: LocationStockCheckDetail,
    meta: { title: "库位盘点详情", requiresAuth: true },
  },
  {
    path: "/stockInOrder",
    name: "StockInOrder",
    component: StockInOrder,
    meta: {
      requiresAuth: true,
    },
  },
  // 收货
  {
    path: "/warein-receive",
    name: "WareInReceive",
    component: WareInReceive,
    meta: { title: "收货", requiresAuth: true },
  },
  {
    path: "/mobile/warein-receive",
    name: "MobileWareInReceive",
    component: WareInReceive,
    meta: { title: "收货", requiresAuth: true },
  },
  {
    path: "/warein-receive/create",
    name: "WareInReceiveCreate",
    component: WareInReceiveCreate,
    meta: { title: "创建收货入库单", requiresAuth: true },
  },
  {
    path: "/warein-receive/single",
    name: "WareInReceiveSingle",
    component: WareInReceiveSingle,
    meta: { title: "单物料收货", requiresAuth: true },
  },
  {
    path: "/warein-receive/multi-pallet",
    name: "WareInReceiveMultiPallet",
    component: WareInReceiveMultiPallet,
    meta: { title: "多物料多托盘归托", requiresAuth: true },
  },
  {
    path: "/warein-receive/redash",
    name: "WareInReceiveRedash",
    component: WareInReceiveRedash,
    meta: { title: "红冲", requiresAuth: true },
  },
  {
    path: "/warein-batch-receive",
    name: "WareInBatchReceive",
    component: WareInBatchReceive,
    meta: { title: "批量收货", requiresAuth: true },
  },
  // 上架
  {
    path: "/warein-putaway",
    name: "WareInPutaway",
    component: WareInPutaway,
    meta: { title: "上架", requiresAuth: true },
  },
  {
    path: "/warein-putaway/detail/:id",
    name: "WareInPutawayDetail",
    component: WareInPutawayDetail,
    meta: { title: "待上架", requiresAuth: true },
  },
  {
    path: "/warein-putaway/scan",
    name: "WareInPutawayScan",
    component: WareInPutawayScan,
    meta: { title: "扫码上架", requiresAuth: true },
  },
  // 移动端上架路由
  {
    path: "/mobile/warein-putaway",
    name: "MobileWareInPutaway",
    component: WareInPutaway,
    meta: { title: "上架", requiresAuth: true },
  },
  {
    path: "/mobile/warein-putaway/detail/:id",
    name: "MobileWareInPutawayDetail",
    component: WareInPutawayDetail,
    meta: { title: "待上架", requiresAuth: true },
  },
  {
    path: "/mobile/warein-putaway/scan",
    name: "MobileWareInPutawayScan",
    component: WareInPutawayScan,
    meta: { title: "扫码上架", requiresAuth: true },
  },
  // 移位
  {
    path: "/stock-transfer",
    name: "StockTransfer",
    component: StockTransfer,
    meta: { title: "移位", requiresAuth: true },
  },
  {
    path: "/mobile/stock-transfer",
    name: "MobileStockTransfer",
    component: StockTransfer,
    meta: { title: "移位", requiresAuth: true },
  },
  {
    path: "/stock-transfer/detail",
    name: "StockTransferDetail",
    component: StockTransferDetail,
    meta: { title: "托盘详情", requiresAuth: true },
  },
  {
    path: "/quality-transfer",
    name: "QualityTransfer",
    component: QualityTransfer,
    meta: { title: "良不良移位", requiresAuth: true },
  },
  {
    path: "/mobile/quality-transfer",
    name: "MobileQualityTransfer",
    component: QualityTransfer,
    meta: { title: "良不良移位", requiresAuth: true },
  },
  // 调拨管理
  {
    path: "/mobile/material-secondment",
    name: "MaterialSecondmentList",
    component: MaterialSecondmentList,
    meta: { title: "调拨", requiresAuth: true },
  },
  // 添加装车单管理路由
  {
    path: "/loading-order",
    name: "LoadingOrderList",
    component: LoadingOrderList,
    meta: { title: "装车单管理", requiresAuth: true },
  },
  {
    path: "/mobile/loading-order",
    name: "MobileLoadingOrderList",
    component: LoadingOrderList,
    meta: { title: "装车单管理", requiresAuth: true },
  },
  {
    path: "/loading-order/detail/:id",
    name: "LoadingOrderDetail",
    component: LoadingOrderDetail,
    meta: { title: "装车扫描", requiresAuth: true },
  },

  // 添加库存管理路由
  {
    path: "/stockQuery",
    name: "StockQuery",
    component: ScanStockQuery, // 已修正为正确导入的组件
    meta: { title: "库存管理", requiresAuth: true },
  },
  {
    path: "/material-stock-query",
    name: "MaterialStockQuery",
    component: MaterialStockQuery,
    meta: { title: "库存查询", requiresAuth: true },
  },
  {
    path: "/mobile/material-stock-query",
    name: "MobileMaterialStockQuery",
    component: MaterialStockQuery,
    meta: { title: "库存查询", requiresAuth: true },
  },
  {
    path: "/stock-ware-query",
    name: "StockWareQuery",
    component: StockWareQuery,
    meta: { title: "库存库位查询", requiresAuth: true },
  },
  {
    path: "/mobile/stock-ware-query",
    name: "MobileStockWareQuery",
    component: StockWareQuery,
    meta: { title: "库存库位查询", requiresAuth: true },
  },
  // 备料管理路由
  {
    path: "/material-preparation",
    name: "MaterialPreparation",
    component: MaterialPreparation,
    meta: { title: "备料管理", requiresAuth: true },
  },
  {
    path: "/prepare-list",
    name: "PrepareList",
    component: PrepareList,
    meta: { title: "备料", requiresAuth: true },
  },
  {
    path: "/mobile/prepare-list",
    name: "MobilePrepareList",
    component: PrepareList,
    meta: { title: "备料", requiresAuth: true },
  },
  {
    path: "/prepare/detail/:id",
    name: "PrepareDetail",
    component: PrepareDetail,
    meta: { title: "备料单", requiresAuth: true },
  },
  // 备料箱码校验
  {
    path: "/mobile/ware-location-check",
    name: "WareLocationCheck",
    component: WareLocationCheck,
    meta: { title: "备料箱码校验", requiresAuth: true },
  },
  // PLS备料路由
  {
    path: "/pls-material-preparation",
    name: "PlsMaterialPreparation",
    component: PlsMaterialPreparation,
    meta: { title: "PLS备料日志", requiresAuth: true },
  },
  {
    path: "/mobile/pls-material-preparation-mobile",
    name: "MobilePlsResourceNoScan",
    component: PlsResourceNoScan,
    meta: { title: "PLS备料", requiresAuth: true },
  },
  // 添加看板页面路由
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { title: "数据看板", requiresAuth: true },
  },
  // 添加我的页面路由
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { title: "个人中心", requiresAuth: true },
  },
  // 添加版本更新记录页面路由
  {
    path: "/update-log",
    name: "UpdateLog",
    component: UpdateLog,
    meta: { title: "版本更新记录", requiresAuth: true },
  },
  // 添加关于我们页面路由
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    meta: { title: "关于我们", requiresAuth: true },
  },
  // 添加修改密码页面路由
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { title: "修改密码", requiresAuth: true },
  },
  // 添加系统设置页面路由
  {
    path: "/system-settings",
    name: "SystemSettings",
    component: SystemSettings,
    meta: { title: "系统设置", requiresAuth: true },
  },
  // 基础数据搜索
  {
    path: "/basic-material-search",
    name: "BasicMaterialSearch",
    component: BasicMaterialSearch,
    meta: { title: "基础数据", requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// 动态路由加载状态（避免移动端恢复时卡死）
let dynamicRoutesLoaded = false;
let dynamicRoutesLoading = null;

const DYNAMIC_ROUTES_ATTEMPT_KEY = "dynamicRoutesAttempted";

const hasRoutePath = (path) => {
  if (!path) return false;
  return router.getRoutes().some((r) => r.path === path);
};

// 初始化动态路由（并发调用复用同一 Promise）
let initDynamicRoutesPromise = null;

export async function initDynamicRoutes() {
  if (dynamicRoutesLoaded) return true;
  if (initDynamicRoutesPromise) return initDynamicRoutesPromise;

  initDynamicRoutesPromise = (async () => {
    try {
      const dynamicRoutes = await addDynamicRoutes();

      if (!Array.isArray(dynamicRoutes) || dynamicRoutes.length === 0) {
        dynamicRoutesLoaded = true;
        return true;
      }

      dynamicRoutes.forEach((route) => {
        try {
          if (route?.name && router.hasRoute(route.name)) return;
          if (route?.path && hasRoutePath(route.path)) return;
          router.addRoute(route);
        } catch (e) {
          console.error("动态添加路由失败:", route?.path, e);
        }
      });

      dynamicRoutesLoaded = true;
      console.log("动态路由添加完成");
      return true;
    } catch (error) {
      console.error("初始化动态路由失败:", error);
      return false;
    } finally {
      initDynamicRoutesPromise = null;
    }
  })();

  return initDynamicRoutesPromise;
}

const markAttempted = () => {
  try {
    sessionStorage.setItem(DYNAMIC_ROUTES_ATTEMPT_KEY, String(Date.now()));
  } catch (e) {
    // ignore
  }
};

const hasAttemptedRecently = () => {
  try {
    const v = sessionStorage.getItem(DYNAMIC_ROUTES_ATTEMPT_KEY);
    if (!v) return false;
    const ts = Number(v);
    if (!Number.isFinite(ts)) return false;
    // 10 秒内不重复触发，避免无限加载
    return Date.now() - ts < 10000;
  } catch (e) {
    return false;
  }
};

const withTimeout = (promise, timeoutMs) => {
  return Promise.race([
    promise,
    new Promise((resolve) => {
      setTimeout(() => resolve(false), timeoutMs);
    }),
  ]);
};

const ensureDynamicRoutes = async () => {
  if (dynamicRoutesLoaded) return true;
  if (!dynamicRoutesLoading) {
    dynamicRoutesLoading = withTimeout(initDynamicRoutes(), 3000).finally(() => {
      dynamicRoutesLoading = null;
    });
  }
  return dynamicRoutesLoading;
};

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const hasToken =
    localStorage.getItem(UIC_AUTH_KEYS.accessToken) ||
    sessionStorage.getItem(UIC_AUTH_KEYS.accessToken);
  const matched = Array.isArray(to.matched) ? to.matched : [];
  const isMatched = matched.length > 0;
  const requiresAuth = matched.some((record) => record.meta.requiresAuth);

  // 1) 优先处理认证：没 token 直接去登录页（避免先请求动态路由导致卡死）
  if (!hasToken) {
    if (
      to.path !== "/login" &&
      (requiresAuth || to.path.startsWith("/mobile") || !isMatched)
    ) {
      next("/login");
      return;
    }
    next();
    return;
  }

  if (to.path === "/login") {
    next("/home");
    return;
  }

  // 2) 登录后尽早拉取动态路由（不阻塞已匹配的静态页）
  if (!dynamicRoutesLoaded) {
    // 未匹配时必须等动态路由完成再重试，避免偶发 No match
    if (!isMatched) {
      if (hasAttemptedRecently()) {
        next("/home");
        return;
      }
      markAttempted();
      const ok = await ensureDynamicRoutes();
      if (ok && hasRoutePath(to.path)) {
        next({ ...to, replace: true });
        return;
      }
      // 兼容旧路径：/mobile/xxx -> /xxx
      if (to.path.startsWith("/mobile/")) {
        const fallback = to.path.replace(/^\/mobile/, "") || "/home";
        if (hasRoutePath(fallback)) {
          next({
            path: fallback,
            query: to.query,
            hash: to.hash,
            replace: true,
          });
          return;
        }
      }
      next("/home");
      return;
    }

    // 已匹配静态路由：后台补齐动态路由，不阻塞跳转
    ensureDynamicRoutes();
  }

  next();
});

export default router;
